module.exports = __webpack_public_path__ + "img/14ne.6f540409.svg";